module.exports = __webpack_public_path__ + "static/media/kran.8cf4f9c0.fbx";